"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coerce = void 0;
/**
 * Coerce a `value` using the coercion logic that is built-in to the guard, returning the newly coerced value.
 * @param guard type-guard used for coercion
 * @param value value to be coerced
 */
function coerce(guard, value) {
    return guard.coerce(value);
}
exports.coerce = coerce;
